import styles from './FJDancePresetList.module.less';
import PropTypes from 'prop-types';
import FJConfig from '../../../../config/FJConfig.js';
import FJLocalStore from '../../../../store/FJLocalStore.js';
import FJHorizontalScrollArrow from '../../../../common/components/FJTab/FJHorizontalScrollArrow.jsx';
import FJVideoPreview from './FJVideoPreview.jsx';
import FJHoverBoardGradation from '../../../../common/components/FJHoverBoard/FJHoverBoardGradation.jsx';

const FJDancePresetList = props => {
    const { dancePresetList = [], onItemClick } = props;

    const _onItemClick = (e, item) => {
        e.stopPropagation();
        onItemClick && onItemClick(item);
    };

    return (
        <div className={styles.preset_box}>
            <div className={styles.preset_title}>{FJLocalStore._('no-inspiration-try-these-styles')}</div>
            <FJHorizontalScrollArrow className={styles.preset_list_box}>
                <div className={styles.preset_list}>
                    {dancePresetList.map((item, index) => {
                        return (
                            <FJHoverBoardGradation
                                key={index}
                                isShowInBorder={true}
                                className={styles.preset_item_img_box}
                            >
                                <div className={styles.preset_item_img_box} onClick={e => _onItemClick(e, item)}>
                                    <FJVideoPreview
                                        className={styles.preset_item_img}
                                        url={
                                            FJConfig.videoEffectDanceStylePreviewPath +
                                            item.previewVideoSmall +
                                            '?v=' +
                                            FJConfig.version
                                        }
                                    />
                                </div>
                            </FJHoverBoardGradation>
                        );
                    })}
                </div>
            </FJHorizontalScrollArrow>
        </div>
    );
};

export default FJDancePresetList;
FJDancePresetList.propTypes = {
    dancePresetList: PropTypes.array,
    onItemClick: PropTypes.func,
};
